import { IBaseItem } from '@shared/stores/BaseItem.store';
import { ISelectOption } from './ISelectOption';
import { getValueLabelOptions } from './getValueLabelOptions';

export function getOptionsByNameId(items: IBaseItem[]): ISelectOption[] {
  return getValueLabelOptions<IBaseItem>(
    items,
    item => item.name,
    item => item.id,
  );
}
